export default "__VITE_ASSET__BWTJYgIb__"